import React from "react"
import styled from "styled-components"
import { H2, LogoHeading } from "../Styles/TextStyles"
import { themes } from "../Styles/ColorStyles"

function BeTheProficient() {
  return (
    <Wrapper>
      <ContentWrapper>
        <Title>A Journey of a Thousand Miles</Title>
        <Subtitle>Begins with a single step!</Subtitle>
        <div className="grid-container">
          <div>
            <Image src="../PM/trophy.svg" />
            <Title>Achieve!</Title>
          </div>
          <div>
            <Image src="../PM/dataArrange.svg" />
            <Title>Progress Insights!</Title>
          </div>
          <div>
            <Image src="../PM/search.svg" />
            <Title>Search!</Title>
          </div>
          <div>
            <Image src="../PM/fixing.svg" />
            <Title>Downtimes? No!</Title>
          </div>
        </div>
      </ContentWrapper>
    </Wrapper>
  )
}

export default BeTheProficient

const Wrapper = styled.div`
  background: linear-gradient(
    180deg,
    #9076e7 100%,
    ${themes.light.backgroundColor} 50%
  );
  overflow: hidden;
  align-content: center;
  align-self: center;
  align-items: center;

  .grid-container {
    display: grid;
    grid-template-columns: 300px 300px;
    grid-template-rows: 300px 300px;
    align-items: center;
    align-content: center;
    align-self: center;
    padding: 100px;
    gap: 50px;
  }
`

const ContentWrapper = styled.div`
  max-width: 1234px;
  padding: 200px;
`

const Title = styled(LogoHeading)`
  color: ${themes.dark.text1};
  text-align: center;
`

const Subtitle = styled(H2)`
  color: ${themes.dark.text2};
  text-align: center;
`

const Image = styled.img`
  max-width: 200px;
  min-width: 200px;
  max-height: 200px;
  min-height: 200px;
  align-self: center;
  align-content: center;
  align-items: center;
`
